<template>
    <tr>
        <td>
            {{getItemInfo("nome")}}
        </td>
        <td>
            {{getItemInfo("sexo")}}
        </td>
        <td>
            {{getItemInfo("dataNascimento")}}
        </td>
        <td>
            {{getItemInfo("email")}}
        </td>
        <td>
            {{getItemInfo("telefone")}}
        </td>
        <td v-if="$store.state.answeradvertising.filters.mode == 'ULTIMA'">
            {{getItemInfo("dataAcesso")}}
        </td>
    </tr>
</template>

<script>
    export default {

        props: {
            dataItem: {
                type: Object,
                required: true,
            }
        },

        computed: {
            item() {
                return this.dataItem
            }            
        },

        methods: {
            getItemInfo(info) {
                return this.item[info] || this.$t("message.generics.message.notInformed")
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@variables";


</style>
